export default function Beneficios() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-32 bg-white">
      <div className="max-w-5xl mx-auto px-8 lg:px-16 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
          ¿Por Qué Elegir el CDE MIPYME?
        </h2>
        <p className="text-lg text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
          Somos tu aliado estratégico para el crecimiento empresarial. Nuestro equipo de expertos te acompaña en cada etapa del desarrollo de tu negocio con metodologías probadas y enfoque personalizado.
        </p>

        <button
          onClick={() => scrollToSection('contacto')}
          className="inline-flex items-center space-x-3 bg-[#5D4037] text-white px-10 py-4 rounded-full font-semibold hover:bg-[#4E342E] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
        >
          <span>Agenda Tu Asesoría Gratuita</span>
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#0066CC]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-line-chart-line text-3xl text-[#0066CC]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Mejora de Gestión</h4>
            <p className="text-sm text-gray-600">Optimiza procesos y toma decisiones informadas</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#2E7D32]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-rocket-line text-3xl text-[#2E7D32]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Mayor Productividad</h4>
            <p className="text-sm text-gray-600">Aumenta la eficiencia y rentabilidad</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#5D4037]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-book-open-line text-3xl text-[#5D4037]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Conocimiento Técnico</h4>
            <p className="text-sm text-gray-600">Accede a expertos y mejores prácticas</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="w-16 h-16 bg-[#0066CC]/10 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-trophy-line text-3xl text-[#0066CC]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2">Competitividad</h4>
            <p className="text-sm text-gray-600">Destaca en el mercado regional</p>
          </div>
        </div>
      </div>
    </section>
  );
}
